import ThumbDownIcon from '@mui/icons-material/ThumbDown'

import SupervisorSuccessForm from '../../../../shared/components/supervisor/supervisor-success-form'

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    minHeight: '100vh',
    height: '100%',
  },

  icon: {
    fontSize: 90,
    mb: 2,
  },
}

const SupervisorRejectedSuccess = () => {
  return (
    <SupervisorSuccessForm
      icon={<ThumbDownIcon color='primary' sx={styles.icon} />}
      mode={'rejected'}
    />
  )
}

export default SupervisorRejectedSuccess
